import useIsLayoutSize from '../utils/useIsLayoutSize';
import { LayoutSize } from '../utils/useLayoutSize';

const useShouldShowFullPageSheet = () => useIsLayoutSize(LayoutSize.mobile);

export default useShouldShowFullPageSheet;
